export const formatTestTitle = (title) => {
  if (!title) {
    return '';
  }
  const match = title.match(/\((.*?)\)\s*-\s*(\d+)/);

  if (match && match[1] && match[2]) {
    return `${match[1]}-${match[2]}`;
  }
  return title;
};
